const BaseModule = require('../../../../90_utils/base/BaseModule');

class IconStats extends BaseModule {

	constructor(el, params) {

		super(el);

		this.$statItemsWrapper = this.$el.find('.stat-items');
		this.$statItems = this.$el.find('.stat-item');
	}

	// basemodule methods

	_domReady(){
	}

	_addListeners(){
	}

	_removeListeners(){
	}

	//

	_matchHeight(){
		this.$statItems.css('height', '');
		this.$statItems.css('height', this.$statItemsWrapper.outerHeight());
	}

	//

	_show(){}

	_hide(){}

	_enable(){ }
	_disable(){ }

	_domUpdate(){
		this._matchHeight();
	}
	_resize(){
		this._matchHeight();
	}
}

module.exports = IconStats;
